import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// api to fetch company details by name
export const fetchCompanyByName = async (companyName) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/companies/company/${encodeURIComponent(companyName)}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company details:", error);
    throw error;
  }
};

// create a new company
export const createNewCompany = async (companyData, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/admin/companies`,
      companyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating new company:", error);
    throw error;
  }
};

// ================ ADMIN COMPANY APIs ================

// fetch all companies
export const fetchAllCompanies = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/companies`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all companies:", error);
    throw error;
  }
};

// fetch company by ID
export const fetchCompanyById = async (companyId) => {
  try {
    const response = await axios.get(`${BASE_URL}/companies/${companyId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching company by ID:", error);
    throw error;
  }
};

// update a company (Admin only)
export const updateCompany = async (companyId, companyData, token) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/admin/companies/${companyId}`,
      companyData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating company:", error);
    throw error;
  }
};

// delete a company (Admin only)
export const deleteCompany = async (companyId, token) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/admin/companies/${companyId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting company:", error);
    throw error;
  }
};
